export default __webpack_public_path__ + "static/media/Arm-straps of Bedlam.96dc41d9.jpg";